import * as React from "react";
import {
  IMobileMenuHeaderProps,
  IMobileMenuHeaderState,
} from "./MobileMenuHeader.types";
import { Icon } from "../Icon/icon";
export class MobileMenuHeader extends React.Component<
  IMobileMenuHeaderProps,
  IMobileMenuHeaderState
> {
  constructor(props: IMobileMenuHeaderProps) {
    super(props);
    this.renderBreadcrumbs = this.renderBreadcrumbs.bind(this);
    this.state = {};
  }

  static defaultProps = {
    isCampaignPage: false,
  };

  private renderBreadcrumbs(pageName: string, i: number) {
    let pageUrl = this.props.activeMenuItem.Breadcrumb.PageUrl[i];
    return (
      <span key={pageUrl} className="mobile-menu__breadcrumb">
        <a href={pageUrl}>{pageName}</a>
      </span>
    );
  }

  public render() {
    return (
      <div className="mobile-menu__header">
        {this.props.activeMenuItem.Breadcrumb.PageUrl.length > 0 && (
          <div className="mobile-menu__breadcrumbs">
            {this.props.activeMenuItem.Breadcrumb.PageName.map(
              this.renderBreadcrumbs
            )}
          </div>
        )}

        <div className="mobile-menu__functions">
          <div>
            {!this.props.isStartPage && (
              <button
                onClick={() => this.props.previousLevelTriggeredCallback()}
                className="mobile-menu__header-icon mobile-menu__header-icon--previous chevron"
                aria-label={
                  this.props.ariaLabelBackInMenu
                    ? this.props.ariaLabelBackInMenu
                    : "Gå tillbaka i menyn"
                }
              />
            )}
          </div>
          <div className="mobile-menu__headline">
            {this.props.activeMenuItem.Name}
          </div>
          <div>
            {!this.props.isStartPage && (
              <button
                onClick={() => this.props.homeTriggeredCallback()}
                className="mobile-menu__header-icon"
                aria-label="Gå till startsidan"
              >
                <Icon
                  className={
                    this.props.isCampaignPage ? "campaign-page__home-icon" : ""
                  }
                  iconType="fontawesome/home"
                />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
